import * as yup from 'yup';
import { requiredPhoneSchema } from '@billda/shared-ui';

export const companyDetailsSchema = yup.object({
  companyName: yup.string().required('Company name is required').max(200),
  companyNumber: yup.string().nullable().max(50).defined(),
  addressLine1: yup.string().required('Address line 1 is required').max(200),
  addressLine2: yup.string().nullable().max(200).defined(),
  city: yup.string().required('City is required').max(100),
  county: yup.string().nullable().max(100).defined(),
  postcode: yup.string().required('Postcode is required').max(20),
  country: yup.string().nullable().max(100).defined(),
  companyEmail: yup
    .string()
    .required('Email is required')
    .email('Must be a valid email')
    .max(254),
  companyPhone: requiredPhoneSchema,
});

export type CompanyDetailsFormData = yup.InferType<typeof companyDetailsSchema>;

export const defaultCompanyDetailsValues: CompanyDetailsFormData = {
  companyName: '',
  companyNumber: null,
  addressLine1: '',
  addressLine2: null,
  city: '',
  county: null,
  postcode: '',
  country: null,
  companyEmail: '',
  companyPhone: '',
};
